import { prisma, PreferencesType, PreferencesCategory } from "client";

// Create or update a preference
export const upsertPreference = async (
  userId: string,
  type: PreferencesType,
  category: PreferencesCategory,
  categoryId: string,
  metaData: any
) => {
  return await prisma.preferences.upsert({
    where: {
      userId_category_categoryId_type: { userId, category, categoryId, type },
    },
    update: { metaData },
    create: { userId, type, category, categoryId, metaData },
  });
};

// Get a specific preference by user, category, and categoryId
export const getPreference = async (
  userId: string,
  type: PreferencesType,
  category: PreferencesCategory,
  categoryId: string
) => {
  return await prisma.preferences.findFirst({
    where: {
      userId,
      category,
      categoryId,
      type,
    },
  });
};

// Get all preferences for a user
export const getUserPreferences = async (userId: string) => {
  return await prisma.preferences.findMany({ where: { userId } });
};

// Update a preference
export const updatePreference = async (
  userId: string,
  type: PreferencesType,
  category: PreferencesCategory,
  categoryId: string,
  metaData: any
) => {
  return await prisma.preferences.update({
    where: {
      userId_category_categoryId_type: { userId, category, categoryId, type },
    },
    data: { metaData, updatedAt: new Date() },
  });
};

// Delete a preference
export const deletePreference = async (
  userId: string,
  type: PreferencesType,
  category: PreferencesCategory,
  categoryId: string
) => {
  return await prisma.preferences.delete({
    where: {
      userId_category_categoryId_type: { userId, category, categoryId, type },
    },
  });
};
